import { useReveal } from "@/lib/hooks";
import { Sparkles } from "lucide-react";

export default function DressCode() {
  const ref = useReveal();
  return (
    <section
      id="dress-code"
      data-testid="dress-code-section"
      className="paper-texture py-12 md:py-20 px-6"
    >
      <div ref={ref} className="reveal max-w-4xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-center">
          <div className="md:col-span-5">
            <p className="text-[10px] tracking-luxe uppercase text-[#6A1E2D] mb-4">
              Dress Code
            </p>
            <h2 className="font-display font-light text-4xl md:text-5xl text-[#1A1818] leading-[1.05]">
              Dress to
              <span className="block italic text-[#6A1E2D]">impress.</span>
            </h2>
          </div>
          <div className="md:col-span-7 border-l border-[#6A1E2D]/15 md:pl-10">
            <p className="font-body text-[#4A4747] text-lg leading-relaxed mb-5">
              <strong className="text-[#1A1818] font-medium">Dress to Impress (Formal).</strong>{" "}
              Sharp suits, chic dresses, and polished looks encouraged — formal
              but not black tie.
            </p>
            <div className="flex flex-wrap gap-2 mt-6">
              {["Sharp suits", "Chic dresses", "Polished looks", "Comfortable shoes for dancing"].map((tag) => (
                <span
                  key={tag}
                  className="inline-flex items-center gap-2 px-4 py-2 border border-[#6A1E2D]/20 text-xs tracking-wide text-[#1A1818] bg-[#FAF9F6]"
                >
                  <Sparkles className="w-3 h-3 text-[#A3C1DA]" strokeWidth={1.6} />
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
